exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nhr[data-v-6b036929]{border-color:gray\n}", ""]);

// exports
